import TapwowLogo from 'assets/TapWowLogo_dark.png'

import './footer.component.css'

export const Footer = () => (
  <footer>
    <h4>Powered by</h4>
    <a href='https://tapwow.net'><img src={TapwowLogo} alt='Tapwow' /></a>
  </footer>
);
